var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_164)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_626_164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0H0V512H512V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_626_164)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_626_164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512C397.385 512 512 397.385 512 256Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_626_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512C397.385 512 512 397.385 512 256Z",
    fill: "#9A2000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.808 64C149.824 64 64 150.016 64 256C64 361.984 149.824 448 255.808 448C361.984 448 448 361.984 448 256C448 150.016 361.984 64 255.808 64ZM388.864 179.2H332.224C326.08 155.2 317.248 132.16 305.728 110.848C341.056 122.944 370.432 147.52 388.864 179.2ZM256 103.168C271.936 126.208 284.416 151.744 292.672 179.2H219.328C227.584 151.744 240.064 126.208 256 103.168ZM107.392 294.4C104.32 282.112 102.4 269.248 102.4 256C102.4 242.752 104.32 229.888 107.392 217.6H172.288C170.752 230.272 169.6 242.944 169.6 256C169.6 269.056 170.752 281.728 172.288 294.4H107.392ZM123.136 332.8H179.776C185.92 356.8 194.752 379.84 206.272 401.152C170.944 389.056 141.568 364.672 123.136 332.8ZM179.776 179.2H123.136C141.568 147.328 170.944 122.944 206.272 110.848C194.752 132.16 185.92 155.2 179.776 179.2ZM256 408.832C240.064 385.792 227.584 360.256 219.328 332.8H292.672C284.416 360.256 271.936 385.792 256 408.832ZM300.928 294.4H211.072C209.344 281.728 208 269.056 208 256C208 242.944 209.344 230.08 211.072 217.6H300.928C302.656 230.08 304 242.944 304 256C304 269.056 302.656 281.728 300.928 294.4ZM305.728 401.152C317.248 379.84 326.08 356.8 332.224 332.8H388.864C370.432 364.48 341.056 389.056 305.728 401.152ZM339.712 294.4C341.248 281.728 342.4 269.056 342.4 256C342.4 242.944 341.248 230.272 339.712 217.6H404.608C407.68 229.888 409.6 242.752 409.6 256C409.6 269.248 407.68 282.112 404.608 294.4H339.712Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebHistory);
export default __webpack_public_path__ + "static/media/webHistory.46e5883ac8e95cf53a7bc0fd7628025f.svg";
export { ForwardRef as ReactComponent };